export function getSelectedRollModeKey(namespace = 'dice-roller') {
  return `arcade-${namespace}:selected-roll-mode`;
}

export function readSelectedRollMode(storage = window.localStorage, namespace = 'dice-roller') {
  return storage?.getItem(getSelectedRollModeKey(namespace)) ?? null;
}

export function writeSelectedRollMode(modeId, storage = window.localStorage, namespace = 'dice-roller') {
  storage?.setItem(getSelectedRollModeKey(namespace), modeId);
}
